// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron","chevronRight":"Chevron_chevronRight","chevronLeft":"Chevron_chevronLeft","open":"Chevron_open"};